import {
  DownOutlined,
  LineChartOutlined,
  UpOutlined
} from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { ReactNode } from 'react';

export interface ReportLegendItem {
  label: string;
  description: string;
  icon?: ReactNode;
  iconClassName?: string;
}

interface CorporateReportInfoBannerProps {
  description: string;
  legendOpen?: boolean;
  showLegendToggle?: boolean;
  onToggleLegend?: () => void;
}

export const CorporateReportInfoBanner = ({
  description,
  legendOpen = false,
  showLegendToggle = false,
  onToggleLegend
}: CorporateReportInfoBannerProps) => {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-violet-100 bg-violet-50 px-4 py-3 sm:flex-row sm:items-start sm:gap-3">
      <div className="flex min-w-0 flex-1 gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-violet-600 text-white">
          <LineChartOutlined className="text-lg" />
        </div>

        <Typography.Paragraph className="!mb-0 min-w-0 flex-1 whitespace-pre-line text-sm text-slate-700">
          {description}
        </Typography.Paragraph>
      </div>

      {showLegendToggle && (
        <Button
          type="link"
          className="!h-auto !px-0 !py-0 self-end text-violet-700 sm:shrink-0 sm:self-center"
          onClick={onToggleLegend}
        >
          {legendOpen ? 'Esconder legenda' : 'Ver legenda'}{' '}
          {legendOpen ? <UpOutlined /> : <DownOutlined />}
        </Button>
      )}
    </div>
  );
};
